import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { MSS_FORMLY_IMPORTS } from '@shared/components/formly/formly-standalone-imports';

@Component({
  templateUrl: 'select.component.html',
  imports: [
    FormsModule,
    NgClass,
    ReactiveFormsModule,
    ...MSS_FORMLY_IMPORTS,
  ],
})
export class SelectFieldTypeComponent extends FieldType {
  public static readonly defaultOptions: FormlyFieldConfig = {
    props: {
      placeholder: 'Please select...',
    },
  };

  public get showPlaceholder(): boolean {
    return !this.props.required || !this.formControl.value;
  }

  public get optionsArray(): any[] {
    return (this.props.options as any[]) ?? [];
  }
}
